<template>
  <div class="carpati">
    <h1>Carpaţi, Karpaten</h1>
    <article>
      Doriţi o prelungare? Faceţi un click pe o posa!
Posele marcat cu "nn" nu sânt de la mine.<br/>
				Klicken Sie auf ein Foto, 
				um eine Vergrößerung zu erhalten<br>
				Mit (nn) markierte Fotos stammen nicht von mir.
    </article>
    <article class="fotos">
      <div class="foto">
        <img src="../assets/fotos/carp_1kl.jpg" width="125" border="0" height="110" alt="Carpaţi, Karpaten"
        @click="callImageClick('Carpaţi, Karpaten', 'carp_1.jpg', $event)">
				<br>Carpaţi, Karpaten
      </div>
      <div class="foto">
        <img src="../assets/fotos/carp_2kl.jpg" width="125" border="0" height="110" alt="Carpaţi, Karpaten"
        @click="callImageClick('Carpaţi, Karpaten', 'carp_2.jpg', $event)">
				<br>Carpaţi, Karpaten
      </div>
      <div class="foto">
        <img src="../assets/fotos/carp_3kl.jpg" width="125" border="0" height="110" alt="Carpaţi, Karpaten"
        @click="callImageClick('Carpaţi, Karpaten', 'carp_3.jpg', $event)">
				<br>Carpaţi, Karpaten
      </div>
      <div class="foto">
        <img src="../assets/fotos/carp_4kl.jpg" width="125" border="0" height="110" alt="Carpaţi, Karpaten"
        @click="callImageClick('Carpaţi, Karpaten', 'carp_4.jpg', $event)">
				<br>Carpaţi, Karpaten
      </div>
    </article>
  </div>
</template>

<script>
export default {
  name: 'home',
  methods: {
  callImageClick(imgText, imgName, event) {
     this.$parent.handleImageClick(imgText, imgName, event);
    }
  }
}
</script>